module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100 organizations content\">\n    <div class=\"add-user-top top\">\n        <div>\n            <h2>")
    ; __append(escapeFn( widget.title ))
    ; __append("</h2>\n        </div>\n        <div>\n            <h3>Общая информация</h3>\n\n            <div name=\"data\" class=\"clearfix users-grid-view\">\n                <div class=\"wh100 table table-0-100\">\n                    <div>\n                        <div name=\"grid\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"add-users-footer footer\">\n        <div name=\"back\" class=\"button\" on-click=\"onBackClick\">Назад</div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}